import React, { Component } from "react";
import { Form, Input, Segment, Dimmer, Loader } from 'semantic-ui-react';
import store from '../store/home-store';
import { observer } from 'mobx-react';

const StatItem = (props) => {
  return (<div className={`home-item ${props.color}`}>
    <div className="item width-60per flex flex-column margin-top-20">
      <div className="item-value">{props.value}</div>
      <div className="item-label">{props.label}</div>
    </div>
    <div className="width-40per">
      <div className="icon"><i class={`fa ${props.icon}`} aria-hidden="true"></i></div>
    </div>
  </div>);
}


class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      counts: [],
      visible: false
    }
  }

  componentDidMount() {
    const { match } = this.props;
    store.loadCount(match.params.id);
  }


  render() {
    const cnt = store.counts;

    return (

      <div className="home">
      {store.loading && (
        <Segment>
          <Dimmer active inverted>
            <Loader inverted>Loading</Loader>
          </Dimmer>
        </Segment>
      )}

      {!store.loading && (
        <React.Fragment>
          <div className="flex flex-row">
            <StatItem color="blue" icon="fa-superpowers" value={cnt[0]} label="Docs stored in BlockChain" />  
            <StatItem color="green" icon="fa-stop-circle-o" value={cnt[1]} label="Docs created today" /> 
            <StatItem color="blue" icon="fa fa-ravelry" value={cnt[2]} label="Docs created this week" /> 
          </div>

          <div className="flex flex-row">
            <StatItem color="green" icon="fa-th-large" value={cnt[3]} label="Users with whom docs have been shared" />
            <StatItem color="blue" icon="fa-linode" value={cnt[4]} label="Docs not shared with anyone" />
            <StatItem color="green" icon="fa fa-grav" value={cnt[5]} label="Docs created previous week" /> 
          </div>

          <div className="flex flex-row">
            <StatItem color="blue" icon="fa-home" value={cnt[6]} label="Pending Reviews" /> 
            <StatItem color="green" icon="fa fa-cloud" value={cnt[7]} label="Reviews Completed" /> 
            <StatItem color="blue" icon="fa fa-futbol-o" value={cnt[8]} label="Docs created this month" />       
          </div>

          <div className="flex flex-row">
            <StatItem color="green" icon="fa-wpexplorer" value={cnt[9]} label="Pending Approvals" /> 
            <StatItem color="blue" icon="fa-tachometer" value={cnt[10]} label="Approvals Done" />  
            <StatItem color="green" icon="fa fa-globe" value={cnt[11]} label="Docs created previous month" />     
          </div>
        
        </React.Fragment>
        
      )}
      </div >

       
    );
  }
}

export default observer(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js